import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { ColumnChart } from "react-chartkick";
import "chartkick";

import { Page, Loadable, DataTable } from "components/support";

import Filter from "./filter";

class ProductSalesReportView extends Component {
  opcionalConfig = {
    identifier: "id",
    columns: [
      {
        accessor: "name",
        Header: "Nome",
        align: "center",
        sortable: false
      },
      {
        id: "result.count",
        accessor: result => result.count,
        Header: "Quantidade Vendida",
        align: "center",
        sortable: false
      }
    ]
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { loading, filters, product, user } = viewModel;
    const result = viewModel.result || [];
    const data = result.slice(0, 8).map(item => {
      return [item.description, item.count];
    });

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Vendas por Opcionais
        </Typography>

        <Filter
          loading={loading}
          filters={filters}
          product={product}
          user={user}
          onChange={filters => presenter.onFilterChange(filters)}
        />
        <Paper>
          <Row style={{ margin: "24px 0px 24px 0px", padding: 16 }}>
            <Col xs={12}>
              <ColumnChart
                ytitle="Quantidade"
                label="Vendidos"
                data={data}
                colors={[
                  [
                    "#3466cc",
                    "#6962ca",
                    "#8d5dc4",
                    "#aa58bb",
                    "#c253af",
                    "#d650a2",
                    "#e54f92",
                    "#f05382"
                  ],
                  [
                    "#3466cc",
                    "#6962ca",
                    "#8d5dc4",
                    "#aa58bb",
                    "#c253af",
                    "#d650a2",
                    "#e54f92",
                    "#f05382"
                  ]
                ]}
              />
            </Col>
          </Row>
        </Paper>
        <Loadable loading={loading}>
          <Paper elevation={1}>
            <Row>
              <Col xs={12}>
                <DataTable
                  manual
                  filterable={false}
                  resultSet={result}
                  page={1}
                  config={this.opcionalConfig}
                  onPageChange={page => presenter.onPageChange(page + 1)}
                />
              </Col>
            </Row>
          </Paper>
        </Loadable>
      </Page>
    );
  }
}

export default ProductSalesReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/opcionais-sales-report/view.jsx